// extracted by mini-css-extract-plugin
module.exports = {"pageCover":"MessageOverlay--pageCover--3g0Gz","flexy":"MessageOverlay--flexy--1pYip","messageBox":"MessageOverlay--messageBox--1rLIm"};